import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { GeoJSON, withLeaflet } from 'react-leaflet';

import { is768Query } from '~/core/scripts/mediaquery-helper';

import './ChoroplethLayer.styl';

class Choropleth extends PureComponent {
  static propTypes = {
    data: PropTypes.object,
    onMouseEnter: PropTypes.func,
    onMouseMove: PropTypes.func,
    onMouseOut: PropTypes.func,
    smoothFactor: PropTypes.number
  }

  static defaultProps = {
    data: null,
    onMouseEnter: () => {},
    onMouseMove: () => {},
    onMouseOut: () => {},
    smoothFactor: 0.5
  }

  getMouseOverHandler = (layer, props) => () => {
    layer.setStyle({ weight: 1 });

    if (layer.bringToFront) {
      layer.bringToFront();
    }

    this.props.onMouseEnter(layer.feature.properties);
  }

  getMouseOutHandler = (layer, props) => () => {
    layer.setStyle({ weight: 0.5 });

    if (layer.bringToBack) {
      layer.bringToBack();
    }

    if (!is768Query()) {
      return false;
    }

    this.props.onMouseOut();
  }

  getMouseMoveHandler = (layer, props) => (evt) => {
    const { containerPoint } = evt;

    this.props.onMouseMove(containerPoint);
  }

  onEachFeature = (feat, layer) => {
    const { properties } = feat;

    layer.on('mouseover', this.getMouseOverHandler(layer, properties));
    layer.on('click', this.getMouseOverHandler(layer, properties));
    layer.on('mouseout', this.getMouseOutHandler(layer, properties));
    layer.on('mousemove', this.getMouseMoveHandler(layer, properties));

    layer.setStyle({ className: 'choropleth-layer' });
  }

  getStyle = (feat) => {
    const { colorizer } = this.props;
    const color = colorizer(feat.properties);

    return {
      color: color,
      weight: 0.5,
      fillColor: color,
      fillOpacity: 0.8
    };
  }

  render() {
    if (!this.props.data) {
      return null;
    }

    return (
      <GeoJSON
        data={this.props.data}
        onEachFeature={this.onEachFeature}
        className={this.props.className}
        style={this.getStyle}
        smoothFactor={this.props.smoothFactor}
      />
    );
  }
}

export default withLeaflet(Choropleth);
